import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all fleet mandates
export const fetchFleetMandates = createAsyncThunk(
  "fleet_mandates/fetchAll",
  async ({ page = 1, status = "", mandate_number = "", mandate_reference = "", driver_id = "", vehicle_id = "",
    has_expire_date = "" }, { rejectWithValue }) => {
    try {
      const normalize = (val) => {
        if (val === "true" || val === true) return 1;
        if (val === "false" || val === false) return 0;
        return "";
      };
      const response = await axios.get(`${BASE_URL}/fleet-mandates?page=${page}&status=${status}&mandate_number=${mandate_number}&mandate_reference=${mandate_reference}&driver_id=${driver_id}&vehicle_id=${vehicle_id}&has_expire_date=${normalize(has_expire_date)}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data; // Return the whole response including pagination
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);

// add fleet mandates
export const addFleetMandates = createAsyncThunk(
  "fleet_mandates/add",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/fleet-mandates`, userData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// add establishment documents comments
export const addFleetMandatesComments = createAsyncThunk(
  "fleet_mandates/comments",
  async ({ comment, id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/fleet-mandates/${id}/comments`, comment, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);

// Fetch all establishment documents once (for filters)
export const fetchAllFleetMandates = createAsyncThunk(
  "fleet_mandates/fetchAllFull",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/fleet-mandates`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load all data";
      return rejectWithValue(message);
    }
  }
);
const FleetMandatesSlice = createSlice({
  name: "fleet_mandates",
  initialState: {
    fleet_mandates: [],
    all_fleet_mandates: [],
    record: null,
    isLoading: false,
    error: null,
    success: null,
    successComment: null,
    errorComment: null,
    successDelete: null,
    errorDelete: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
      state.successComment = null;
      state.errorComment = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFleetMandates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFleetMandates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.fleet_mandates = action.payload.data.data;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchFleetMandates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(fetchAllFleetMandates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllFleetMandates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.all_fleet_mandates = action.payload.data.data;
      })
      .addCase(fetchAllFleetMandates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load all fleet mandates";
      })
      .addCase(addFleetMandates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addFleetMandates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addFleetMandates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(addFleetMandatesComments.pending, (state) => {
        state.isLoading = true;
        state.errorComment = null;
      })
      .addCase(addFleetMandatesComments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successComment = action.payload.message;
      })
      .addCase(addFleetMandatesComments.rejected, (state, action) => {
        state.isLoading = false;
        state.errorComment = action.payload || "Failed to add data";
      });
  },
});

export const { clearState } = FleetMandatesSlice.actions;
export default FleetMandatesSlice.reducer;